import {
    GET_AUTHORIZATION_FOR_APPLICATION,
    GET_USER_DATA,
    TOGGLE_DARKMODE,
    LOGIN_USER,
    LOGOUT_USER
} from "./types"
import axios from "../auth/axiosAuth"
import { backendURL, APPLICATION_ID } from "../config"

export const getAuthorizationForCurrentApplication =
    (associateOID) => async (dispatch) => {
        const res = await axios.get(
            `${backendURL}/authorization/user/application/${associateOID}/${APPLICATION_ID}`
        )
        dispatch({
            type: GET_AUTHORIZATION_FOR_APPLICATION,
            payload: {
                permissions: res.data,
                authenticated: res.data?.length > 0 && true
            }
        })
    }

export const getUserData = (googleID) => async (dispatch) => {
    const res = await axios.get(`${backendURL}/user/google/${googleID}`)
    dispatch({ type: GET_USER_DATA, payload: res.data[0] })
}

export const toggleDarkMode = (userData) => async (dispatch) => {
    const newUserData = {
        ...userData,
        DarkMode: userData.DarkMode === "light" ? "dark" : "light"
    }
    await axios.put(`${backendURL}/user`, newUserData)
    dispatch({ type: TOGGLE_DARKMODE })
}

export const loginUser = (user) => (dispatch) => {
    dispatch({ type: LOGIN_USER, payload: user })
}

export const logoutUser = () => (dispatch) => {
    dispatch({ type: LOGOUT_USER })
}
